module.exports = __webpack_public_path__ + "img/DrySystem_Overview-DS_2.1e0aca5d.jpg";